import type { Utility } from '../../../types/utility';
import { mqMin } from '../../breakpoints';

const base: Utility.VariantCSSKeys<LogoVariantsType> = {
  default: {
    '& > a': {
      '& > img': {
        height: '30px',
        width: '200px',
      },
    },
  },
  learningCampus: {
    '& > a': {
      '& > img': {
        height: '36px',
        width: '136px',
        objectFit: 'none',
        objectPosition: 'left',
        [mqMin.tablet]: {
          width: '360px',
          objectFit: 'contain',
        },
      },
    },
  },
};

const edu: Utility.VariantCSSKeys<LogoVariantsType> = {
  default: {
    '& > a': {
      '& > img': {
        height: '50px',
        width: '300px',
      },
    },
  },
  learningCampus: {},
};

const logo: Utility.VariantKeyModes<LogoVariantsType> = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu,
    scale: base,
    spark: base,
  },
};

export type LogoVariantsType = 'default' | 'learningCampus';
export const logoVariants = Object.keys(base) as LogoVariantsType[];

export default logo;
